<template>
  <v-main v-if="ready">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9" md="9">
          <v-row>
            <div class="text-left my-5 col col-5">
              <h3>
                {{ courseName }}
                <span v-if="!isGuest">{{ grade + '-й клас' }}</span>
              </h3>
              <div id="evaluation">
                Оцінка за урок: <span>{{ evaluationResult }}</span>
              </div>
            </div>
            <div class="text-right my-5 col col-7">
              <div>
                <span v-if="!$vuetify.breakpoint.xsOnly">{{
                  'Звернутися з питанням за темою уроку можна до вчителя ' +
                  teacher.firstName +
                  ': '
                }}</span>
                <div v-if="!$vuetify.breakpoint.xsOnly" id="contact">
                  <a
                    :href="
                      'mailto:' +
                      teacher.email +
                      '?subject=' +
                      courseName +
                      ', ' +
                      nameLesson
                    "
                    >{{ teacher.email }}</a
                  >

                  <div>
                    <span v-if="!$vuetify.breakpoint.xsOnly"> або </span>
                  </div>

                  <v-btn
                    large
                    depressed
                    text
                    color="primary"
                    outlined
                    elevation="3"
                    @click="openChat()"
                    ><div
                      v-if="hasUnreadMessages"
                      :class="{ shake: hasUnreadMessages }"
                      class="circle"
                    ></div>
                    Чат</v-btn
                  >
                  <div v-if="hasUnreadMessages">у вас є повідомлення</div>
                </div>
              </div>
            </div>
          </v-row>
        </v-col>
        <div class="content-wrapper">
          <center>
            <h1 class="display-2 font-weight-bold mb-4 name-lessons">
              {{ nameLesson }}
            </h1>
          </center>

          <div ref="lessonPage">
            <div>
              <div v-html="lessonText" />
              <div
                v-if="!showEvaluation && needShowChangeStatus"
                class="study-lesson"
              >
                <div class="label">
                  Якщо все зрозумів - натисни "Вивчив"
                </div>
                <v-btn
                  v-if="needShowChangeStatus"
                  class="evaluation-contorl"
                  large
                  color="primary"
                  @click="changeLessonStatus"
                  >вивчив</v-btn
                >
              </div>
            </div>
          </div>
        </div>

        <section
          v-for="item in videoLinks"
          :key="item.name"
          class="container px-3"
          id="video"
        >
          <div class="subheading mb-12 text-center">
            <h2 class="font-weight-bold mb-6 display-2">{{ item.name }}</h2>
          </div>
          <div
            class="mx-auto v-card v-sheet theme--light elevation-24"
            style="height: 400px; max-width: 800px;"
          >
            <iframe
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen="allowfullscreen"
              frameborder="0"
              height="100%"
              :src="item.link"
              width="100%"
            ></iframe>
          </div>
        </section>
        <EvaluationDeck
          v-if="showEvaluation"
          :isExam="isExam"
          :evaluationDeck="evaluationDeck"
        ></EvaluationDeck>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';
import popupEnum from '@/enums/popupEnum';
import EvaluationDeck from '@/components/Base/EvaluationDeck/EvaluationDeck';
import debounce from 'lodash/debounce';
import GoogleAnaliticService from '@/services/GoogleAnaliticService';

export default {
  name: 'ClassPage',
  components: {
    EvaluationDeck,
  },
  data() {
    const debounceUpdate = debounce(this.$_updateActivity, 400);
    return {
      time: new Date(),
      ready: false,
      drawer: true,
      color: 'primary',
      colors: ['primary', 'blue', 'success', 'red', 'teal'],
      right: false,
      permanent: true,
      miniVariant: false,
      expandOnHover: false,
      background: false,
      debounceUpdate,
    };
  },
  computed: {
    hasUnreadMessages() {
      return this.$store.getters['ChatStore/hasUnreadMessages'];
    },
    needShowChangeStatus() {
      const status = this.$store.getters['CurrentLessonStore/status'];
      return status === 0;
    },
    showEvaluation() {
      return this.evaluationDeck && this.evaluationDeck.hasEvaluations();
    },
    evaluationResult() {
      return this.$store.getters['CurrentLessonStore/getEvaluationResult'];
    },
    isGuest() {
      return this.$store.getters['UserStore/isGuest']();
    },
    isExam() {
      return this.$store.getters['CurrentLessonStore/isExam'];
    },
    status() {
      return this.$store.getters['CurrentLessonStore/status'];
    },
    lessonText() {
      return this.$store.getters['CurrentLessonStore/getLessonText'];
    },
    teacher() {
      return this.$store.getters['CurrentLessonStore/getTeacher'];
    },
    videoLinks() {
      return this.$store.getters['CurrentLessonStore/getVideoLinks'];
    },
    nameLesson() {
      return this.$store.getters['CurrentLessonStore/getNameLesson'];
    },
    courseName() {
      return this.$store.getters['CurrentLessonStore/getCourseName'];
    },
    lessonImages() {
      return this.$store.getters['CurrentLessonStore/getLessonImages'];
    },
    evaluationDeck() {
      return this.$store.getters['CurrentLessonStore/getEvaluationDeck'];
    },
    grade() {
      return this.$store.getters['CurrentLessonStore/getGrade'];
    },
    user() {
      return this.$store.getters['UserStore/getUser'];
    },
    chatId() {
      return this.$store.getters['CurrentLessonStore/getChatId'];
    },
  },
  async created() {
    const payload = {
      lessonId: this.getLessonId(),
    };
    const courseId = this.$route.query.courseId;
    this.$store.commit('LessonsStore/setCourseId', courseId);
    await this.$store.dispatch('CurrentLessonStore/getLesson', payload);
    this.initTrackProgress();

    this.ready = true;
  },

  mounted() {
    this.addRealUrl();
    this.iframeWrapper();
  },
  destroyed() {
    this.$_stopLesson();
    document.removeEventListener('visibilitychange', this.$_focusFunction);
    document.removeEventListener('mousemove', this.debounceUpdate);
    if (typeof this.nameLesson === 'string') {
      const spendTimeMs = this.time
        ? new Date().getTime() - this.time.getTime()
        : 0;
      const minutes = Math.floor(spendTimeMs / 1000 / 60) % 60;
      GoogleAnaliticService.trackUserAction(
        this.$store,
        `Провів у уроці: ${this.nameLesson} ${minutes}хв`
      );
    }
  },
  watch: {
    nameLesson(newVal) {
      if (newVal) {
        GoogleAnaliticService.trackUserAction(this.$store, newVal);
      }
    },
  },
  methods: {
    initTrackProgress() {
      this.$_startLesson();
      window.onbeforeunload = (e) => {
        this.$_stopLesson();
      };
      document.addEventListener('mousemove', this.debounceUpdate);
      document.addEventListener('visibilitychange', this.$_focusFunction);
    },
    changeLessonStatus() {
      this.$store.dispatch('CurrentLessonStore/changeLessonStatus', {
        lessonId: this.getLessonId(),
      });
    },
    getLessonId() {
      return this.$route.params.lessonId;
    },
    $_updateActivity() {
      const payload = {
        lessonId: this.getLessonId(),
      };
      this.$store.dispatch('UserActivityStore/studyInProgress', payload);
    },
    $_focusFunction() {
      if (document.visibilityState === 'visible') {
        this.$_startLesson();
      } else {
        this.$_stopLesson();
      }
    },
    $_startLesson() {
      const payload = {
        lessonId: this.getLessonId(),
      };
      this.$store.dispatch('UserActivityStore/startLesson', payload);
    },
    $_stopLesson() {
      this.$store.dispatch('UserActivityStore/stopLesson');
    },
    openChat() {
      this.$store.dispatch('PopupStore/openPopup', {
        popupName: popupEnum.CHAT_POPUP,
        popupContext: {
          chatId: this.chatId,
        },
      });
    },
    addRealUrl() {
      setTimeout(() => {
        const serverUrl = this.$store.getters['ConfigStore/getServerUrl'];
        const lessonPage = this.$refs.lessonPage;
        const images = lessonPage.querySelectorAll('img');
        images.forEach((image) => {
          const src = image.getAttribute('src');
          if (/^http/.test(src)) {
            return;
          }
          const parseUrl = new URL(serverUrl);
          const realUrl = parseUrl.origin + src;
          image.setAttribute('src', realUrl);
        });
      }, 500);
    },

    courseItemsEventHandler: function (payload) {
      const { type, data } = payload;
      switch (type) {
        case 'getLesson':
          this.$_loadLessons(data);
          break;
      }
    },
    $_loadLessons: function (data) {
      const { courseId } = data;
      this.$store.dispatch('LessonsStore/loadLessons', { courseId });
    },
    iframeWrapper() {
      setTimeout(() => {
        let frames = document.getElementsByTagName('iframe');
        let arrFrames = [...frames];
        arrFrames.map((item) => {
          item.parentNode.classList.add('video');
        });
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.content-wrapper {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 15px 0 15px;
}
@media screen and (max-width: 600px) {
  img {
    height: auto;
    width: 100%;
  }
}

.play-button,
.pause-button {
  border-style: none;
  padding: 10px;
  margin: 10px;
  border-radius: 40px;

  .theme--light.v-icon {
    color: #117973;
  }
}
.hide {
  display: none;
}
.audio-label {
  position: relative;
  left: 78px;
  top: 47px;
}

.study-lesson {
  display: flex;
  align-items: center;
  flex-direction: column;

  .label {
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 600px) {
  .video {
    position: relative;
    height: 0;
    padding-bottom: 56.25%;
    display: block;
  }

  .video iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.circle {
  position: absolute;
  background: red;
  width: 10px;
  height: 10px;
  border-radius: 50px 50px 50px 50px;
  left: 43px;
  top: -17px;
}

.shake {
  animation: shake 3s cubic-bezier(0.36, 0.07, 0.19, 0.97) both infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  0% {
    transform: translate(0, 0);
  }
  1.78571% {
    transform: translate(5px, 0);
  }
  3.57143% {
    transform: translate(0, 0);
  }
  5.35714% {
    transform: translate(5px, 0);
  }
  7.14286% {
    transform: translate(0, 0);
  }
  8.92857% {
    transform: translate(5px, 0);
  }
  10.71429% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
